import { buttonVariants } from '@/app/common/components/button/buttonVariants'
import { Card, CardContent } from '@/app/common/components/Card'
import PageLoader from '@/app/common/components/PageLoader'
import { WarningIcon } from '@/app/common/icons/support'
import { ScholarshipAwardHistoryQueries } from '@/queries/scholarship-award-history/queries'
import { AppRoutePaths } from '@/routing/route_paths'
import { selectSelectedProgram } from '@/storage/programs/slice'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import AwardHistoryTable from './award-history-table'

export default function AwardHistoryPage() {
  const program = useSelector(selectSelectedProgram)

  const academicTermsQuery = useQuery(
    ScholarshipAwardHistoryQueries.getAcademicTerms(
      {
        programId: program.id,
      },
      {
        select: (data) => {
          const selectedAcademicTermId = program.academic_term_type_id

          const activeAcademicTerms = data.filter(
            (term) =>
              term.academic_term.academic_term_type_id ===
              selectedAcademicTermId
          )

          return activeAcademicTerms
        },
      }
    )
  )

  return (
    <div>
      <PageLoader query={academicTermsQuery}>
        {(academicTerms) => {
          if (academicTerms.length === 0) {
            return (
              <Card className="max-w-2xl mx-auto">
                <CardContent className="flex flex-col items-center justify-center py-12 px-6 text-center">
                  <WarningIcon className="text-4xl text-primary-500 mb-4" />
                  <h3 className="text-2xl font-medium text-gray-800 mb-2">
                    No academic terms found
                  </h3>
                  <p className="text-gray-600 mb-6">
                    Academic terms need to be set up before you can view award
                    history. Please set up academic terms to continue.
                  </p>
                  <Link
                    className={buttonVariants({
                      variant: 'primary',
                      size: 'md',
                    })}
                    to={AppRoutePaths.academic_terms.view}
                  >
                    Go to Academic Terms
                  </Link>
                </CardContent>
              </Card>
            )
          }

          return <AwardHistoryTable academicTerms={academicTerms} />
        }}
      </PageLoader>
    </div>
  )
}
